import { useEffect, useState } from "react";

import {
    Box,
    Chip,
} from "@mui/material";

import MUIDataTable from "mui-datatables";


import { useNavigate } from "react-router-dom";

import { paymentGatewayApi } from "../API/paymentGatewayApi";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb";
import GatewayLogo from "./GatewayLogo";

export default function GatewayList() {

    const navigate = useNavigate();

    const [rows, setRows] = useState([]);

    const loadGateways = async () => {

        const response =
            await paymentGatewayApi.getAll();

        const list = response.data?.data || response.data || [];
        setRows(
            [...list].sort((a, b) => (a.priority ?? 9999) - (b.priority ?? 9999))
        );
    };

    useEffect(() => {
        loadGateways();
    }, []);

    const deleteGateway = async (
        id
    ) => {

        if (!window.confirm("Delete this gateway?")) {
            return;
        }

        await paymentGatewayApi.delete(id);

        loadGateways();
    };

    const columns = [

        {
            name: "logoUrl",
            label: "Logo",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => (
                    <GatewayLogo logoUrl={value} size={30} />
                ),
            },
        },

        {
            name: "id",
            label: "ID",
        },

        {
            name: "displayName",
            label: "Gateway",
            options: { customBodyRender: (v, m) => v || m.rowData[1] || '' },
        },

        {
            name: "code",
            label: "Code",
        },

        {
            name: "priority",
            label: "Priority",
        },

        {
            name: "active",
            label: "Status",
            options: {
                customBodyRender: (value) => (
                    <Chip
                        label={value ? "ACTIVE" : "INACTIVE"}
                        color={value ? "success" : "default"}
                        size="small"
                    />
                ),
            },
        },

        {
            name: "id",
            label: "Actions",
            options: {
                customBodyRender: (value) => (

                    <div className="tw-flex tw-gap-2">
                        <button
                            className="btn btn-sm hovbuttonColour"
                            onClick={() =>
                                navigate(
                                    `/gateways/${value}/edit`
                                )
                            }
                        >
                            Edit
                        </button>
                        <button
                            className="btn btn-sm btn-danger"
                            onClick={() =>
                                deleteGateway(value)
                            }
                        >
                            Delete
                        </button>
                    </div>
                ),
            },
        },
    ];

    const options = {
        filterType: "dropdown",
        selectableRows: "none",
        responsive: "standard",
    };

    return (
        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <div className="UI-container">
                    <div className="UI-card">
                        <div className="UI-header">
                            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/superadminmasters" }, { name: "Payment Gateways", path: null }]} />
                            <div className="UI-header-content">
                                <div>
                                    <h1 className="UI-title">
                                        Payment Gateways
                                    </h1>
                                    <p className="UI-subtitle">
                                        List of all payment gateways
                                    </p>
                                </div>
                                <div className="UI-header-actions">
                                    <button className="UI-btn UI-btn-primary"
                                        onClick={() =>
                                            navigate("/gateways/create")
                                        }
                                    >
                                        Add Gateway
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="UI-form-container">
                            <Box>

                                <MUIDataTable
                                    title=""
                                    data={rows}
                                    columns={columns}
                                    options={options}
                                />

                            </Box>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}